<template>
	<section class="our-team-section">
		<div class="row header-row">
			<div class="columns column12 align-center">
				<picture>
					<source :srcset="item.sectionOurTeamImageWebp" type="image/webp" />
					<source :srcset="item.sectionOurTeamImage" />
					<img
						:src="item.sectionOurTeamImage"
						:alt="item.sectionOurTeamImageAlt"
						class="icon-image"
						loading="lazy"
					/>
				</picture>
				<h2>{{ item.sectionOurTeamTitle }}</h2>
				<blockquote>{{ item.sectionOurTeamQuote }}</blockquote>
			</div>
		</div>
		<div class="row content-row">
			<div class="columns column6 content" v-html="item.sectionOurTeamContentLeft" />
			<div class="columns column6 content" v-html="item.sectionOurTeamContentRight" />
		</div>
	</section>
</template>

<script setup>
defineProps({
	item: {
		type: Object,
		default: () => ({
			sectionOurTeamImage: { type: String, default: '' },
			sectionOurTeamImageWebp: { type: String, default: '' },
			sectionOurTeamImageAlt: { type: String, default: '' },
			sectionOurTeamTitle: { type: String, default: '' },
			sectionOurTeamQuote: { type: String, default: '' },
			sectionOurTeamContentLeft: { type: String, defaults: '' },
			sectionOurTeamContentRight: { type: String, defaults: '' },
		}),
	},
});
</script>

<style lang="scss" scoped>
.our-team-section {
	background: var(--dark-background-color);

	h2 {
		color: #fff;
		margin-bottom: 50px;
	}

	blockquote {
		font-family: var(--header-font-family);
		color: var(--cta-color-blue);
		text-transform: uppercase;
		font-size: 2.5em;
		max-width: 700px;
		line-height: 1.7;
		margin: 50px auto;
		font-weight: 700;
	}

	.content-row {
		max-width: 1350px;

		.content {
			padding: 0 100px;
			text-align: left;
		}
	}
}

@media (max-width: 880px) {
	.our-team-section blockquote {
		font-size: 2em;
	}

	.our-team-section .content-row .content {
		padding: 0 50px;
	}
}
</style>
